import {Component, Input} from '@angular/core';
import {CartStatus} from '../../shopping-cart/Cart';
import {NgClass, NgIf} from '@angular/common';

@Component({
  selector: 'app-cart-status-badge',
  standalone: true,
  imports: [
    NgClass,
    NgIf,
  ],
  templateUrl: './cart-status-badge.component.html',
  styleUrl: './cart-status-badge.component.scss'
})
export class CartStatusBadgeComponent {

  protected readonly CartStatus = CartStatus;

  @Input() cartStatus?: CartStatus;

  get visible(): boolean {
    return this.cartStatus === CartStatus.POPending || this.cartStatus === CartStatus.Cancelled;
  }

  cartStatusDisplayText(status: CartStatus): string {
    switch (status) {
      case CartStatus.POPending:
        return 'P.O. Pending';
      case CartStatus.Cancelled:
        return 'Order Canceled';
      default:
        return '';
    }
  }
}
